import { useState } from 'react';
import { ProductFeature } from '../types';

let selectedRecords: ProductFeature[] = [];
let listeners: (() => void)[] = [];

const notifyListeners = () => {
  listeners.forEach(listener => listener());
};

export const useProductFeaturesSelection = () => {
  const [, forceUpdate] = useState({});
  
  const rerender = () => forceUpdate({});
  
  if (!listeners.includes(rerender)) {
    listeners.push(rerender);
  }

  const setSelectedRecords = (records: ProductFeature[]) => {
    selectedRecords = records;
    notifyListeners();
  };

  const clearSelection = () => {
    selectedRecords = [];
    notifyListeners();
  };

  return {
    selectedRecords,
    setSelectedRecords,
    clearSelection,
    handleClearSelection: clearSelection,
    hasSelection: selectedRecords.length > 0
  };
};